import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useGetFullReservation } from "../../-hooks/use-get-full-reservation";
import { Form } from "../../-components/reservation-form";
import { Skeleton } from "@/components/ui/skeleton";
import { BookOpen, CalendarRange } from "lucide-react";
import { T } from "@/i18n";

export const Route = createFileRoute(
  "/(reservations)/reservations/calendar/$id/edit",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { isLoading, data } = useGetFullReservation(id);
  const navigate = useNavigate();
  return (
    <Form
      clients={data.clients ?? []}
      accommodations={data.accommodations ?? []}
      reservationdays={data.days ?? []}
      services={data.services ?? []}
      reservation={data.reservation}
      isLoading={isLoading}
      onSuccess={(id) => {
        navigate({ to: "/reservations/calendar/$id", params: { id } });
      }}
      crumbs={[
        {
          content: (
            <>
              <T tKey="reservations.calendar.title" />{" "}
              <CalendarRange width={16} height={16} />
            </>
          ),
          href: "/reservations/calendar",
        },
        {
          content: (
            <>
              {isLoading || !data.reservation ? (
                <Skeleton className="h-3 w-28" />
              ) : (
                (data.reservation.agencyReservationNumber ??
                data.reservation.id)
              )}
              <BookOpen width={16} height={16} />
            </>
          ),
          href: "/reservations/calendar/$id",
          params: { id },
        },
      ]}
    />
  );
}
